import { entityMembersFromKeys } from '@neptune/shared/entity-domain';

import { isCompareDataDTO as isCompareDataDTOV1 } from './compare-data-v1';
import { upgrade as upgradeFromPrevious } from './compare-data-v1.upgrade';
import {
  type CompareDataDTOUpToV2,
  type CompareDataDTOV2,
  isCompareDataDTO as isCompareDataDTOV2,
  version,
} from './compare-data-v2';

export function upgrade(raw: CompareDataDTOUpToV2): CompareDataDTOV2 {
  if (isCompareDataDTOV2(raw)) {
    return raw;
  }

  const input = isCompareDataDTOV1(raw) ? raw : upgradeFromPrevious(raw);

  return {
    version,
    workspaceName: input.workspaceName,
    projectIdentifier: input.projectIdentifier,
    compare: {
      runMembers: entityMembersFromKeys(input.compare.runIds),
      experimentMembers: entityMembersFromKeys(input.compare.experimentNames),
    },
  };
}
